// frontend/src/components/ClaseRecursosTree.jsx
import React, { useState } from 'react';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import './ClaseRecursosTree.css';

const NIVEL_BADGES = {
  1: { cls: 'crt-badge-n1', label: 'N1' },
  2: { cls: 'crt-badge-n2', label: 'N2' },
  3: { cls: 'crt-badge-n3', label: 'N3' },
};

const ClaseRecursosTreeNode = ({ node, onCrearHijo, onEditar, onEliminar, level = 0 }) => {
  const [isExpanded, setIsExpanded] = useState(level < 2);
  const hasChildren = node.children && node.children.length > 0;
  const nivel = node.nivel_actual || node.nivel || 1;
  const badge = NIVEL_BADGES[nivel] || { cls: 'crt-badge-n1', label: `N${nivel}` };
  const indent = level * 1.5;

  return (
    <div className="crt-node">
      <div
        className={`crt-row${level === 0 ? ' crt-row-root' : ''}${node.imputa ? ' crt-row-imputa' : ''}`}
        style={{ paddingLeft: `${0.75 + indent}rem` }}
      >
        {/* Toggle */}
        <button
          className={`crt-toggle${hasChildren ? '' : ' crt-toggle-hidden'}`}
          onClick={() => hasChildren && setIsExpanded(!isExpanded)}
          tabIndex={hasChildren ? 0 : -1}
        >
          {hasChildren ? (isExpanded ? '▾' : '▸') : ''}
        </button>

        {/* Nivel badge */}
        <span className={`crt-badge ${badge.cls}`} title={`Nivel ${nivel}`}>
          {badge.label}
        </span>

        {/* Código */}
        <span className="crt-codigo">{node.codigo_completo || node.codigo}</span>

        {/* Nombre */}
        <span className="crt-nombre">
          {node.nombre}
          {node.imputa && <span className="crt-imputa-tag">Imputa</span>}
          {node.cuenta_imputable_nombre && (
            <span className="crt-cuenta-tag" title={`Cuenta: ${node.cuenta_imputable_codigo} - ${node.cuenta_imputable_nombre}`}>
              {node.cuenta_imputable_codigo}
            </span>
          )}
          {node.descripcion && (
            <span className="crt-desc-icon" title={node.descripcion}>i</span>
          )}
        </span>

        {/* Acciones */}
        <span className="crt-actions">
          {(node.puede_tener_hijos || nivel < 3) && (
            <button
              className="crt-btn crt-btn-add"
              onClick={() => onCrearHijo(node)}
              title="Agregar subclase"
            >+</button>
          )}
          <button
            className="crt-btn crt-btn-edit"
            onClick={() => onEditar(node)}
            title="Editar"
          ><FiEdit size={12} /></button>
          <button
            className="crt-btn crt-btn-del"
            onClick={() => onEliminar(node)}
            title="Eliminar"
          ><FiTrash2 size={12} /></button>
        </span>
      </div>

      {hasChildren && isExpanded && (
        <div className="crt-children">
          {node.children.map(child => (
            <ClaseRecursosTreeNode
              key={child.id}
              node={child}
              onCrearHijo={onCrearHijo}
              onEditar={onEditar}
              onEliminar={onEliminar}
              level={level + 1}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const ClaseRecursosTree = ({ tree, onCrearHijo, onEditar, onEliminar }) => {
  if (!tree || tree.length === 0) return null;
  return (
    <div className="crt-tree">
      {tree.map(node => (
        <ClaseRecursosTreeNode
          key={node.id}
          node={node}
          onCrearHijo={onCrearHijo}
          onEditar={onEditar}
          onEliminar={onEliminar}
        />
      ))}
    </div>
  );
};

export default ClaseRecursosTree;
